export const PalliativePhasesNote = (): JSX.Element => (
  <p>
    Note for palliative phases: An episode of admitted patient palliative care included in the subacute and non-acute stream data may comprise of a single phase or multiple phases, depending on changes in the patient's condition. Data for the entire episode is presented via the subacute and non-acute stream, whereas data for individual phases (where data is available at the phase level) is presented via the palliative care phases stream.
  </p>
)
